import * as tslib_1 from "tslib";
import { themr } from '@nextiva/analytics-lib';
import { relativeToLabel } from "../../utils/date-range";
import cx from 'classnames';
import moment from 'moment-timezone';
import React, { Component } from 'react';
import Styles from "./DateRangeLabel.css";

var DateRangeLabel =
/** @class */
function (_super) {
  tslib_1.__extends(DateRangeLabel, _super);

  function DateRangeLabel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DateRangeLabel.prototype.render = function () {
    var _a;

    var _b = this.props,
        theme = _b.theme,
        dateRange = _b.dateRange,
        timezone = _b.timezone,
        isRealTime = _b.isRealTime,
        startDateFormat = _b.startDateFormat,
        endDateFormat = _b.endDateFormat,
        isDarkTheme = _b.isDarkTheme,
        dataTest = _b.dataTest;
    return React.createElement("span", {
      className: cx(theme.dateRangeLabel, (_a = {}, _a[theme.themeDark] = isDarkTheme, _a)),
      "data-test": dataTest
    }, React.createElement("span", {
      className: theme.datetime
    }, dateRange.type === 'relative' ? React.createElement("span", null, React.createElement("span", {
      className: theme.date
    }, relativeToLabel(dateRange, false)), dateRange.round && " (rounded)") : function () {
      var start = moment.utc(dateRange.start).tz(timezone);
      return React.createElement("span", {
        key: "custom-start"
      }, React.createElement("span", {
        className: theme.date
      }, start.format(startDateFormat)), React.createElement("span", {
        className: theme.time
      }, start.format('hh:mm A')));
    }()), React.createElement("span", {
      className: theme.divider
    }, " \u2014 "), React.createElement("span", {
      className: theme.datetime
    }, dateRange.type === 'relative' || isRealTime ? React.createElement("span", null, React.createElement("span", {
      className: theme.date
    }, "Now")) : function () {
      var end = moment.utc(dateRange.end).tz(timezone);
      return React.createElement("span", null, React.createElement("span", {
        className: theme.date
      }, end.format(endDateFormat)), React.createElement("span", {
        className: theme.time
      }, end.format('hh:mm A')));
    }()));
  };

  DateRangeLabel.defaultProps = {
    startDateFormat: 'M/DD/YY',
    endDateFormat: 'M/DD/YY',
    isDarkTheme: false
  };
  return DateRangeLabel;
}(Component);

export default themr(DateRangeLabel, Styles);